import { TextField } from "@mui/material";
import { StandardTextFieldProps } from "@mui/material/TextField";
import * as React from "react";
import { IMaskInput } from "react-imask";

////////////////////////////////////////////////////////////////////////////

interface InputMaskProps {
    onChange: (event: { target: { name: string; value: string; }; }) => void;
    name: string;
    mask: string;
    unmaskedValue?: boolean;
}

interface IProps extends Omit<StandardTextFieldProps, "InputProps" | "inputProps">, Omit<InputMaskProps, "onChange" | "name"> {
    maxLength?: number;
}

export const MASK_NUMERIC_CHAR = "0";

////////////////////////////////////////////////////////////////////////////

///
const InputMask = React.forwardRef<HTMLElement, InputMaskProps>((props, ref) => {
    const { onChange, mask, unmaskedValue = true, ...other } = props;


    /* DEFAULT MASK DEFINITIONS
    https://imask.js.org/guide.html
    0 - any digit
    a - any letter
    * - any char
    [] - make input optional
    {} - include fixed part in unmasked value
    ` - prevent symbols shift back
    */

    return (
        <IMaskInput
            {...other}
            mask={mask}
            unmask={unmaskedValue}
            inputRef={ref as React.RefCallback<HTMLTextAreaElement | HTMLInputElement>}
            onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
        />
    );
});

////////////////////////////////////////////////////////////////////////////

export const MprcTextFieldMask: React.FC<IProps> = (props) => {
    const { mask, maxLength, unmaskedValue, ...rest } = props;

    if (mask.length > 0)
        return (
            <TextField {...rest} slotProps={{ input: { inputComponent: InputMask as any, inputProps: { mask: mask, maxLength, unmaskedValue } } }} />
        );

    return <TextField {...rest} slotProps={{ input: { inputProps: { maxLength } } }} />;
};
